export const getProductNotifyMePopupUnderlayStyle = (
    baseZIndex: number | undefined,
    offsetZIndex: number
) => {
    if (baseZIndex !== undefined && Number.isFinite(baseZIndex)) {
        return {
            'z-index': `${baseZIndex + offsetZIndex}`
        };
    }

    return undefined;
};
